Vue.component('inventory', {
    props: [],
    data() {
        return {
            previewCount: 0,
        };
    },
    created() {
        Bus.$on('previewAssetRemoved', this.getReadyToPost);
        this.getReadyToPost();
    },
    beforeDestroy() {
        Bus.$off('previewAssetRemoved', this.getReadyToPost);
    },
    methods: {
        getReadyToPost() {
            const self = this;
            axios.get('/api/team/assets?filter[status]=1&count=true', {}).then((response) => {
                self.previewCount = this.$vueData.getData(response);
            });
        },
    },
});
